import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_COUNTRIES = `${API_URL}/api/v1/countries`;
export const SET_SOS_DETAILS = `${API_URL}/api/v1/parent/accouunt`;

export function getCountries(payload) {
  return axiosInstance({
    url: GET_COUNTRIES,
    method: "GET",
    params: payload,
  });
}

export function setSosDetails(payload) {
  return axiosInstance({
    url: SET_SOS_DETAILS,
    method: "PUT",
    params: payload,
  });
}
